import { ArrowLeft } from 'lucide-react';

const BONZA_LOGO = "https://customer-assets.emergentagent.com/job_2b31ab0e-18bf-40dd-b209-ee04ef532201/artifacts/pjhpmexv_Colour%20Landscape%20Logo%20-%20Large%20file%20size.png";

export const Header = () => {
  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a 
            href="https://bonzabfs.com.au" 
            className="flex items-center"
            data-testid="header-logo-link"
          >
            <img 
              src={BONZA_LOGO} 
              alt="Bonza Business & Franchise Sales" 
              className="h-8 sm:h-10"
            />
          </a>
          
          {/* Back to Bonza link */}
          <a 
            href="https://bonzabfs.com.au"
            className="flex items-center gap-2 text-sm font-medium text-[#5a2f92] hover:text-[#4a2578] transition-colors"
            data-testid="back-to-bonza-link"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">Back to Bonza</span>
            <span className="sm:hidden">Back</span>
          </a>
        </div>
      </div>
    </header>
  );
};
